import { SimplesSyndikosSelect } from '../SyndikosSelect';
import { ISyndikosSelectV2Props } from './types';

export const SimplesSyndikosSelectV2 = SimplesSyndikosSelect as React.FC<ISyndikosSelectV2Props>;
